import pueDailyList from "./pue.daily.list";
import pueDailyDetail from "./pue.daily.detail";

export default {

    namespaced: true,

    modules: {
        "list" : pueDailyList,
        "detail" : pueDailyDetail,
    },

}